.root {
    svg {
        width: var(--spacer-24);
        height: 1lh;
        fill: currentColor;
        flex-shrink: 0;

        path:global(.plus-vertical-stroke) {
            transform: scale(1);
            transform-origin: center;
            transition: transform 500ms;
        }
    }

    & [data-expanded] {
        svg path:global(.plus-vertical-stroke) {
            transform: scale(0);
        }

        .panel {
            max-height: 500px;
            opacity: 1;
        }
    }
}

.entry {
    border-bottom: 1px solid var(--pale-navy);
}

.header {
    font: var(--font-h-24);
}

.button {
    composes: buttonReset from "../../styles/composable/utility.module.css";
    composes: outline from "../../styles/composable/utility.module.css";
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: var(--spacer-24);
    text-align: left;
    padding-block: var(--spacer-32);
}

.panel {
    transition:
        max-height 500ms,
        padding 500ms,
        opacity 300ms;
    max-height: 0;
    opacity: 0;
    padding-bottom: var(--spacer-32);
    max-width: calc(100% * 9 / 12);

    &[hidden] {
        content-visibility: unset;
        pointer-events: none;
        padding-bottom: 0;
    }
}
